import { ContentTypeCodenames } from "services/cms/models/contentTypeCodenames";
import { StaticCard } from "services/cms/models/staticCard";
import { StaticCardList } from "services/cms/models/staticCardList";

import richTextResolver, { ResolvedRichText } from "./richTextResolver";
import staticCardResolver, { ResolvedStaticCard } from "./staticCardResolver";

export type ResolvedStaticCardList = {
    codename: string;
    sectionHeading?: string;
    copy?: string;
    cards: ResolvedStaticCard[];
    caveatText?: ResolvedRichText;
    type: ContentTypeCodenames.StaticCardList;
};

const staticCardListResolver = (data: StaticCardList): ResolvedStaticCardList => {
    const linkedCards = data.elements.cards.linkedItems as StaticCard[];
    const sectionHeading = data.elements.sectionHeading?.value;
    return {
        codename: data.system.codename,
        sectionHeading,
        copy: data.elements.copy?.value,
        cards: linkedCards.map((item) => staticCardResolver(item, false, !!sectionHeading)),
        caveatText: richTextResolver({ html: data.elements.caveatText?.value }),
        type: ContentTypeCodenames.StaticCardList,
    };
};

export default staticCardListResolver;
